import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const IconButton = (props) => {
  const {
    icon,
    className,
    ...buttonProps
  } = props;
  const classes = classnames(
    'ds-btn-icon',
    className,
  );
  return (
    <button
      className={classes}
      {...buttonProps}
    >
      {icon}
    </button>
  );
};

IconButton.defaultProps = {
  className: '',
};

// Also accepts all <button /> attributes
IconButton.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
};

export default IconButton;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Buttons/IconButton.jsx